import { useCallback, useMemo, useState } from 'react';
import { CompanyResultRow } from './useCompanyResults';
import { filterAndSort, groupRows, hasPublished, ResultsViewOptions, SortKey } from './resultsModel';

/**
 * État de consultation (recherche, filtre, groupement, tri) commun aux vues desktop et
 * mobile : une seule implémentation, deux rendus.
 */
export function useResultsView(rows: CompanyResultRow[]) {
  const [searchTerm, setSearchTerm] = useState('');
  const [publishedOnly, setPublishedOnly] = useState(true);
  const [groupBySector, setGroupBySector] = useState(true);
  const [sort, setSort] = useState<ResultsViewOptions['sort']>({ key: 'symbole', direction: 'asc' });

  const publishedCount = useMemo(() => rows.filter(hasPublished).length, [rows]);

  const visibleRows = useMemo(
    () => filterAndSort(rows, { searchTerm, publishedOnly, groupBySector, sort }),
    [rows, searchTerm, publishedOnly, groupBySector, sort]
  );

  const groups = useMemo(() => groupRows(visibleRows, groupBySector), [visibleRows, groupBySector]);

  /** Bascule desc → asc sur la même clé ; une nouvelle clé part en desc. */
  const toggleSort = useCallback((key: SortKey) =>
    setSort(prev => ({ key, direction: prev.key === key && prev.direction === 'desc' ? 'asc' : 'desc' })), []);

  return {
    searchTerm, setSearchTerm,
    publishedOnly, setPublishedOnly,
    groupBySector, setGroupBySector,
    sort, setSort, toggleSort,
    publishedCount, visibleRows, groups,
  };
}
